import { getAuthHeaders } from './authHeader';
import { isProRequired, notifyProRequired, proRequiredError } from './proRequired';

const BASE_URL = process.env.NEXT_PUBLIC_SERVER_URL;

// The backend works out whose follows these are from the signed-in user's
// token (Authorization header), so no user id is ever sent.

export const followAPI = {
	async getFollows() {
		const response = await fetch(
			`${BASE_URL}follows/user`,
			{ cache: 'no-store', headers: await getAuthHeaders() }
		);
		// Not Pro (any more): treat as having none rather than failing.
		if (isProRequired(response)) {
			notifyProRequired();
			return { follows: [] };
		}
		if (!response.ok) throw new Error('Failed to fetch follows');
		return response.json();
	},

	async addFollow(brandId) {
		const response = await fetch(`${BASE_URL}follows/add`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				...(await getAuthHeaders()),
			},
			body: JSON.stringify({ brandId }),
		});
		if (isProRequired(response)) throw proRequiredError();
		if (!response.ok) throw new Error('Failed to follow brand');
		return response.json();
	},

	async removeFollow(brandId) {
		const response = await fetch(`${BASE_URL}follows/remove`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				...(await getAuthHeaders()),
			},
			body: JSON.stringify({ brandId }),
		});
		if (isProRequired(response)) throw proRequiredError();
		if (!response.ok) throw new Error('Failed to unfollow brand');
		return response.json();
	},
};
